import { useState, useEffect } from 'react';

const DEFAULT_WIDGET_CONFIG = {
  overlayWidgets: [
    { key: 'timer', enabled: true },
    { key: 'kanban', enabled: true },
    { key: 'rotatingStats', enabled: true }
  ],
  rotatingStats: {
    cycleDurationMs: 6000,
    items: [
      { key: 'lastSub', enabled: true, label: 'LAST SUB' },
      { key: 'lastFollow', enabled: true, label: 'LAST FOLLOW' },
      { key: 'topCheer', enabled: true, label: 'TOP CHEER' },
      { key: 'checkInStreak', enabled: true, label: 'CHECK-IN STREAK' },
      { key: 'subs', enabled: true, label: 'SUBS' },
      { key: 'followers', enabled: true, label: 'FOLLOWERS' },
      { key: 'firstToday', enabled: true, label: 'FIRST TODAY' }
    ]
  },
  appearance: {
    labelColor: '#d4c4a8',
    valueColor: '#f5f0e6',
    accentColor: '#e8b298',
    progressBarColor: '#a65241'
  }
};

export default function useWidgetConfig(channelName) {
  const [config, setConfig] = useState(DEFAULT_WIDGET_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchConfig = async () => {
      try {
        const response = await fetch(
          `/api/admin?action=get-widget-config-public&channel=${encodeURIComponent(channelName)}`
        );
        if (!cancelled && response.ok) {
          const data = await response.json();
          if (data.success && data.config) {
            setConfig(data.config);
          }
        }
      } catch (err) {
        console.error('Error fetching widget config:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchConfig();
    return () => { cancelled = true; };
  }, [channelName]);

  const isWidgetEnabled = (key) => {
    const widget = config.overlayWidgets.find(w => w.key === key);
    return widget ? widget.enabled : true;
  };

  const getEnabledWidgets = () => {
    return config.overlayWidgets.filter(w => w.enabled);
  };

  return { config, loading, isWidgetEnabled, getEnabledWidgets };
}
